<template>
  <p-button
    :variant="!isInOrder ? 'light' : 'primary'"
    class="btn-item"
    @click="orderButtonClick"
  >
    <fa
      icon="shopping-cart"
      class="shopping-cart"
    />
  </p-button>
</template>

<script>
import PButton from '~/components/core/PButton'

export default {
  name: 'OrderButton',
  components: { PButton },
  props: {
    isInOrder: {
      type: Boolean,
      default: false
    },
    isOrderButtonDisable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEditable: false
    }
  },
  methods: {
    orderButtonClick () {
      this.$emit('orderClick')
    }
  }
}
</script>

<style scoped>
.btn-item {
    padding: 7px;
}
.shopping-cart {
  width : 15px;
  height : 15px;
}
</style>
